import { CSSProperties } from 'react';

import leaderxLogo from '../../assets/Loaders/splash-screen-logo.png';
import clonebook from '../../assets/icons/new-logo.svg';

interface ILogoLoader {
  containerStyle: CSSProperties;
}
/**
 * displays a loader
 * @component
 * @param {string} width
 * @param {string} height
 * @param {string} text
 * @returns <LogoLoader {...{props}} />
 */
const LogoLoader = ({ containerStyle }: ILogoLoader) => {
  const safeAreaInsets = { top: 0, bottom: 0 };
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div
        style={{
          width: '100vw',
          height: '100vh',
          paddingTop: safeAreaInsets.top,
          paddingBottom: safeAreaInsets.bottom,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(135deg, #E8F0FE 0%, #F0F4F8 100%)',
          ...containerStyle
        }}>
        <img style={{ width: '40%' }} src={window.location.pathname.includes('0') || window.location.pathname.includes('blog') ? clonebook : clonebook} alt="loading-logo" />
      </div>
    </div>
  );
};
export default LogoLoader;
